import { ApplicationConfig } from '@angular/core';
import { provideNoopAnimations } from '@angular/platform-browser/animations';
import { definePreset } from '@primeng/themes';
import Nora from '@primeng/themes/nora';
import { providePrimeNG } from 'primeng/config';

const srcPreset = Nora;

const primary = Object.fromEntries(Object.entries(srcPreset.semantic!.primary!).map(([k]) => [k, `{sky.${k}}`] as const));

const btnRoot = srcPreset.components!.button!.colorScheme!.light!.root!;

const successBtn = JSON.parse(JSON.stringify(btnRoot.success).replaceAll('green.', 'lime.'));

const warnBtn = JSON.parse(JSON.stringify(btnRoot.warn).replaceAll('orange.', 'yellow.'));

const preset = definePreset(srcPreset, {
  semantic: { primary },
  components: {
    button: {
      colorScheme: {
        light: {
          root: {
            success: successBtn,
            warn: warnBtn,
          },
        },
      },
    },
  },
});

export const appConfig: ApplicationConfig = {
  providers: [
    provideNoopAnimations(),
    providePrimeNG({
      theme: {
        preset,
        options: {
          prefix: 'p',
          darkModeSelector: '.dark',
          cssLayer: {
            name: 'primeng',
            order: 'theme, base, bootstrap, primeng',
          },
        },
      },
    }),
  ],
};
